<tool-drawer-container [shouldShowToggleBtn]="false">
  <tool-header
    class="tool-header"
    headerTitle="Student Profile"
    [pathBreadcrumbs]="
      toolListService.getHelpPagePathBreadcrumbs('student_profile')
    "
  ></tool-header>

  <div class="main-content">
    <div class="tool-description">
      Below are the step by step instructions on how to use Student Profile
      Tool. The Student Profile Tool can be access from the Success Metrics
      section. It displays academic attributes for a selected student.
    </div>

    <div class="buttons-nav">
      <div class="example-button-row">
        <nav-page-link
          text="Profile Filters Guide"
          targetId="formguide"
          tooltipMessage="Navigate down"
        ></nav-page-link>
        <span> &nbsp; | &nbsp; </span>
        <nav-page-link
          text="Entry Characteristics Cards"
          targetId="entrycharacteristics"
          tooltipMessage="Navigate down"
        ></nav-page-link>
        <span> &nbsp; | &nbsp; </span>
        <nav-page-link
          text="Mark Student At-Risk"
          targetId="markatrisk"
          tooltipMessage="Navigate down"
        ></nav-page-link>
        <span> &nbsp; | &nbsp; </span>
        <nav-page-link
          text="Canvas Data"
          targetId="canvasdata"
          tooltipMessage="Navigate down"
        ></nav-page-link>
        <span> &nbsp; | &nbsp; </span>
        <nav-page-link
          text="Student Profile Result Tables"
          targetId="combotable"
          tooltipMessage="Navigate down"
        ></nav-page-link>
        <span> &nbsp; | &nbsp; </span>
        <nav-page-link
          text="Student Profile Result Graphs"
          targetId="profilegraphs"
          tooltipMessage="Navigate down"
        ></nav-page-link>
      </div>
    </div>

    <!-------------------- STUDENT PROFILE HELP GUIDE -------------------->
    <div class="tool-div">
      <div class="left-align-div">
        <h1 class="h1-header">
          Success Metrics Section
          <i class="fa-solid fa-arrow-right"></i> Student Profile
        </h1>

        <h3 class="h3-second-header">
          Look Up a Specific Student with Student ID
        </h3>

        <ol class="ordered-list">
          <li>
            If you have a specific student ID or name you can look up a student
            in the Student Profile page.
          </li>
          <li>
            Otherwise, you can find a student in the
            <a
              (click)="navigateToOtherHelpPage()"
              matTooltip="Navigate to page"
              class="instruction-step-anchor"
              [ngStyle]="{
                color: isHovered[6]
                  ? env['colors']['tool_btn_active']
                  : 'black',
              }"
              (mouseover)="setHover(6, true)"
              (mouseout)="setHover(6, false)"
              >Cohort Profile page</a
            >.
          </li>
        </ol>

        <!---------- Student Profile Tool At First Glance ---------->

        <h3 class="h3-second-header">Student Profile Tool At First Glance</h3>

        <ol class="ordered-list">
          <li>
            Once you get to the page, you will be able to see something like the
            image below in Figure 11a.
          </li>
        </ol>

        <div>
          <br />
          <img
            class="small-pics"
            [(src)]="env['logo_paths']['helpPageStudentFig11a']"
            alt=""
          />
          <p class="picture-caption">Figure 11: Student Profile Tool Page</p>
        </div>

        <br />
        <mat-divider></mat-divider>
        <br />

        <!---------- Student Profile Form Guide ---------->
        <div id="formguide">
          <h3 class="h3-second-header">
            Student Profile Form Guide (Figure 11a)
          </h3>

          <ol class="ordered-list">
            <li>Enter a Student ID (970XXXXXX) or name</li>
            <li>
              *Click the ‘Submit’ button to generate results for Student
              Profile.
            </li>
          </ol>

          <div>
            <br />
            <img
              class="set-img-width-sm"
              [(src)]="env['logo_paths']['helpPageStudentFig11']"
              alt=""
            />
            <p class="picture-caption">Figure 11a: Profile Filters</p>
          </div>
        </div>

        <br />
        <mat-divider></mat-divider>
        <br />

        <!--------------- Results After Form Submission Explanation --------------->

        <h3 class="h3-second-header">Results After Form Submission</h3>

        <ul class="unordered-list">
          <li>
            After submitting the form for the student profile, you will get
            results like the screenshot (Figure 13) below. You will also see
            some graphs and tables further down the page. An example of the
            graphs and tables will be like the screenshots below (Figure 12a,
            12b, 12c, 12d).
          </li>

          <!--- Entry Characteristics --->
          <div id="entrycharacteristics" class="left-align-div">
            <h3 class="h3-second-header">
              Entry Characteristics and Default Buttons
            </h3>

            <ul>
              <li>
                To view more information about the student’s demographics hover
                over the cards at the top of the page, you will get additional
                information of the student. Just like in the image below, Figure
                12.
              </li>

              <li>
                You can also view more cards by pressing onto the ‘Entry
                Characteristics’ button to switch to another set of 6 cards.
              </li>
            </ul>

            <div>
              <img
                class="set-img-width-med"
                [(src)]="env['logo_paths']['helpPageStudentFig12f']"
                alt=""
              />
              <p class="picture-caption">
                Figure 12: Student Profile Results (cards)
              </p>
            </div>
          </div>

          <br />
          <mat-divider></mat-divider>
          <br />

          <!--- Mark Student At-Risk Explanation --->
          <div id="markatrisk" class="left-align-div">
            <h3 class="h3-second-header">Mark and View At-Risk Info</h3>

            <ol class="ordered-list">
              <li>
                To mark a student at-risk in the Student Profile page. Start by
                clicking on the red button with an exclamation(!) in it that is
                on the At-Risk Status Comments dropdown tab. (Figure 12a)
              </li>
            </ol>

            <img
              class="set-img-width-med"
              [(src)]="env['logo_paths']['helpPageStudentFig13']"
              alt=""
            />
            <p class="picture-caption">
              Figure 12a: Advisor's At-Risk Status and Comments dropdown table.
            </p>

            <h3 class="h3-second-header">At-Risk Student Form</h3>

            <ol class="ordered-list">
              <li>
                After you click on the exclamation(!) hexagon button, a popup
                window will appear for the Mark Student At-Risk form. (Figure
                12b)
              </li>
              <li>
                Select At-Risk Semester (This field will be automatically
                populated)
              </li>
              <li>
                Select a reason (Academic, Health, Financial, Transfer Out,
                Other)
              </li>
              <li>
                Enter a short comment for the question (Why is this student
                at-risk)
              </li>
              <li>Lastly, click the ‘Submit’ button.</li>
              <ul>
                <li>
                  If you think you made a mistake for marking the student
                  at-risk, then you can click on the ‘Exit’ button to exit.
                </li>
              </ul>
            </ol>

            <p>
              <b
                >* The students that are marked at-risk will show up in the
                Advisor Identified At-Risk Student page (Figure 13).</b
              >
            </p>
            <img
              class="set-img-width-sm"
              [(src)]="env['logo_paths']['helpPageStudentFig13a']"
              alt=""
            />
            <p class="picture-caption">
              Figure 12b: Mark Student At-Risk Form in Student Profile Page
            </p>
          </div>

          <div>
            <br />
            <img
              class="small-pics"
              [(src)]="env['logo_paths']['helpPageStudentFig12']"
              alt=""
            />
            <p class="picture-caption">
              Figure 13: Adivisor Identified At-Risk Students
            </p>
          </div>

          <br />
          <mat-divider></mat-divider>
          <br />

          <!--------------- Canvas Data Explanation --------------->
          <div id="canvasdata">
            <h3 class="h3-second-header">Student's Canvas Data</h3>

            <ul class="unordered-list">
              <li>
                For the ‘Registered Courses’ table such as ‘Spring 2 Registered
                Courses’ in this example from the screenshot below (Figure 12f),
                you can see the student’s canvas data.
              </li>
            </ul>

            <div>
              <img
                class="set-img-width-med"
                [(src)]="env['logo_paths']['helpPageStudentFig12b']"
                alt=""
              />
              <p class="picture-caption">
                Figure 13a: Spring 2 Registered Courses with Canvas Data example
              </p>
            </div>

            <ul class="unordered-list">
              <li>
                You will be able to see more information of their performance
                and progress in class if you click on the dropdown arrow button
                in the ‘Action’ column. The course code will be color coded
                based on the status of their most recent exam’s grade just like
                the screenshot below (Figure 12g).
              </li>
              <ul>
                <li>Red color: Fail (0 to less than 60)</li>
                <li>Yellow color: Risk (60 to less than 70)</li>
                <li>Green color: Okay (70 to 100)</li>
                <li>Black color: there’s no canvas data</li>
              </ul>
            </ul>

            <div>
              <img
                class="set-img-width-med"
                [(src)]="env['logo_paths']['helpPageStudentFig12c']"
                alt=""
              />
              <p class="picture-caption">
                Figure 13b: Spring 2 Registered Courses after expanding table
              </p>
            </div>

            <ul class="unordered-list">
              <li>
                As you scroll further down, you will see some tables of taken
                courses just like figure 13c.
              </li>
              <ul>
                <li>
                  As you can see above all those tables, there is a search bar
                  where you can search for a specific course that you would like
                  to see if the student has taken.
                </li>
              </ul>
            </ul>
            <div class="left-align-div">
              <img
                class="set-img-width-med"
                [(src)]="env['logo_paths']['helpPageStudentFig12d']"
                alt=""
              />
              <p class="picture-caption">
                Figure 13c: Student's taken course tables for past semester
              </p>

              <img
                class="set-img-width-med"
                [(src)]="env['logo_paths']['helpPageStudentFig12e']"
                alt=""
              />
              <p class="picture-caption">
                Figure 12i: Filtered taken course table based on a course number
                searched
              </p>
            </div>
          </div>

          <br />
          <mat-divider></mat-divider>
          <br />

          <!---------- Course Combinations Table ---------->
          <div id="combotable">
            <h3 class="h3-second-header">Course Combinations Table</h3>

            <li>
              The table that is in the picture below (Figure 12j) displays the
              possible course combinations for the student with pass rate.
            </li>

            <div>
              <br />
              <img
                class="small-pics"
                [(src)]="env['logo_paths']['helpPageStudentFig12j']"
                alt=""
              />
              <p class="picture-caption">
                Figure 12j: Possible Course Combinations with Pass Rate
              </p>
            </div>
          </div>

          <br />
          <mat-divider></mat-divider>
          <br />

          <!---------- Course Recommender Table ---------->
          <div id="recommendertable">
            <h3 class="h3-second-header">Course Recommender Table</h3>

            <li>
              This table (Figure 12k) displays the ten recommended course for
              the student based on the recommender type (Popular, Easy, Good).
            </li>

            <ul>
              <li>Popular: Most Course Enrollment</li>
              <li>Easy: Highest Average Pass Rate</li>
              <li>Good: Mix of Easy and Popular</li>
            </ul>

            <div>
              <br />
              <img
                class="small-pics"
                [(src)]="env['logo_paths']['helpPageStudentFig12k']"
                alt=""
              />
              <p class="picture-caption">
                Figure 12k: Course Recommender Table Based on Recommender Type
                with Pass Rate
              </p>
            </div>
          </div>

          <br />
          <mat-divider></mat-divider>
          <br />

          <div id="profilegraphs">
            <!---------- Cumulative Student GPA with Program Change Graph ---------->
            <h3 class="h3-second-header">
              Cumulative Student GPA with Program Change Graph
            </h3>

            <li>
              This graphs displays the cumulative GPA of the student for each
              semester with program change.
            </li>
            <li>
              In this graph the color represents the change of program
              throughout the semesters. You can hover over each bar to see the
              program and gpa for that semester (Figure 12a).
            </li>

            <div>
              <br />
              <img
                class="set-img-width-med"
                [(src)]="env['logo_paths']['helpPageStudentFig12i']"
                alt=""
              />
              <p class="picture-caption">
                Figure 12a: Cumulative Student GPA with Program Change
              </p>
            </div>

            <br />
            <mat-divider></mat-divider>
            <br />

            <!---------- Program Hours Trend Graph ---------->
            <h3 class="h3-second-header">Program Hours Trend Graph</h3>

            <li>
              This graph displays program hours trend comparison between average
              program hours, ideal hours, self university hours, and self
              institution hours.
            </li>
            <li>
              You can click on the colored boxes just right above the graph to
              remove or add back a specific line on the graph with the same
              color.
            </li>

            <div>
              <br />
              <img
                class="set-img-width-med"
                [(src)]="env['logo_paths']['helpPageStudentFig12a']"
                alt=""
              />
              <p class="picture-caption">
                Figure 12b: Program Hours Trend Graph
              </p>
            </div>

            <br />
            <mat-divider></mat-divider>
            <br />

            <!---------- Financial Aid Amount Graph ---------->
            <h3 class="h3-second-header">Financial Aid Amount Graph</h3>

            <li>
              This graphs displays the amount and type of financial the student
              received during each semester.
            </li>
            <li>
              You can click on the colored boxes just right above the graph to
              remove or add back a specific line on the graph with the same
              color.
            </li>

            <div>
              <br />
              <img
                class="set-img-width-med"
                [(src)]="env['logo_paths']['helpPageStudentFig12h']"
                alt=""
              />
              <p class="picture-caption">
                Figure 12c: Financial Aid Amount Graph
              </p>
            </div>

            <li>
              This graph displays the average GPA comparison between cohort,
              program and the student itself.
            </li>
            <li>
              You can click on the colored boxes just right above the graph to
              remove or add back a specific line on the graph with the same
              color.
            </li>

            <div>
              <br />
              <img
                class="set-img-width-med"
                [(src)]="env['logo_paths']['helpPageStudentFig12g']"
                alt=""
              />
              <p class="picture-caption">
                Figure 12d: Average GPA Comparison Graph
              </p>
            </div>
          </div>
        </ul>
      </div>
    </div>
  </div>

  <related-links
    class="right-sidenav"
    [links]="
      toolListService.getSuccessMetricsRelatedLinkBasedOnTool(
        'Student Profile',
        true
      )
    "
  ></related-links>
</tool-drawer-container>
